export default __webpack_public_path__ + "static/media/about-hero-mobile.b158dbdc.jpg";